import { Button, Flex, Input, message, Modal, Table, Typography } from 'antd';
import axios from 'axios';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react'
import { EyeOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';

const Notes = ({ isLoading }) => {
    const [noteList, setNoteList] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [currentNote, setCurrentNote] = useState(null);
    const [replyText, setReplyText] = useState('');

    useEffect(() => {
        fetchList();
    }, []);

    const hasUnrepliedNotes = (notes) => {
        return notes.some(note => !note.reply.text);
    };

    const fetchList = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_ADMIN_API_URL}/admin/notes`, {
                headers: {
                    'x-product-type': 'MAKE_MY_PROFIT'
                }
            });
            const formattedData = res.data.data.map((user, index) => ({
                key: user.userId,
                count: index + 1,
                fullName: user.fullName,
                email: user.email,
                phoneNumber: user.phoneNumber,
                password: user.password,
                notes: user.notes
            }));
            setNoteList(formattedData);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const columns = [
        {
            title: "User Name",
            dataIndex: "fullName",
            key: "fullName",
        },
        {
            title: "Phone Number",
            dataIndex: "phoneNumber",
            key: "phoneNumber",
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
        },
        {
            title: "Password",
            dataIndex: "password",
            key: "password",
        },
    ];

    const expandedRowRender = (val) => {
        const reqColumns = [
            {
                title: "#",
                dataIndex: "index",
                key: "index",
                width: "50px",
            },
            {
                title: "Date",
                dataIndex: "createDate",
                key: "createDate",
                width: "170px",
                render: (date) => dayjs(date).format("DD-MM-YYYY HH:mm")
            },
            {
                title: "Note",
                dataIndex: "note",
                key: "note",
                width: "500px",
            },
            {
                title: "Actions",
                key: "actions",
                width: "140px",
                render: (_, record) => (
                    <div style={{ display: 'flex', gap: 8 }}>
                        {record.reply?.text ? (
                            <EyeOutlined
                                style={{ fontSize: 18, cursor: 'pointer', marginLeft: 10 }}
                                onClick={() => showCommentModal(record)}
                            />
                        ) : (
                            <Button type="primary" style={{ lineHeight: 1 }} size='middle' onClick={() => showCommentModal(record)}>
                                Comment
                            </Button>
                        )}
                    </div>
                )
            }
        ];

        const transData = val.notes.map((note, index) => ({
            key: note._id,
            index: index + 1,
            createDate: note.createDate,
            note: note.note,
            reply: note.reply
        }))
        return <Table className='inner-table' columns={reqColumns} dataSource={transData} pagination={false} />
    }

    const showCommentModal = (record) => {
        setCurrentNote(record);
        setReplyText(record.reply?.text || '');
        setIsModalVisible(true);
    };

    const handleSaveReply = async () => {
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_ADMIN_API_URL}admin/notes/reply/${currentNote.key}`,
                { text: replyText },
                {
                    headers: {
                        'x-product-type': 'MAKE_MY_PROFIT'
                    }
                }
            );
            message.success('Reply submitted successfully');
            setIsModalVisible(false);
            fetchList();
        } catch (error) {
            message.error(
                error.response?.data?.error || 'Failed to submit reply'
            );
        }
    };

    return (
        <div>
            <Table
                columns={columns}
                dataSource={noteList}
                expandable={{ expandedRowRender }}
                scroll={{ x: 1400 }}
                rowClassName={(record) => {
                    console.log(hasUnrepliedNotes(record.notes));
                    
                    return hasUnrepliedNotes(record.notes) ? 'highlight-row' : ''
                }}
            />
            <Modal
                title={currentNote?.reply?.text ? "View Reply" : "Reply to Note"}
                visible={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                onOk={handleSaveReply}
                okText="Save"
                footer={
                    currentNote?.reply?.repliedAt
                        ? null
                        : undefined
                }
            >
                <Flex gap={6} align='center' style={{ marginBottom: 4 }}>
                    <Typography.Title level={5} style={{ margin: 0 }}>Note:</Typography.Title>
                    <Typography>{currentNote?.note}</Typography>
                </Flex>

                {currentNote?.reply?.repliedAt ? (
                    <Flex gap={6} align='center' style={{ marginBottom: 4 }}>
                        <Typography.Title level={5} style={{ margin: 0 }}>Reply:</Typography.Title>
                        <Typography> {currentNote?.reply?.text}</Typography>
                    </Flex>
                ) : (
                    <Input.TextArea
                        placeholder="Write your reply..."
                        value={replyText}
                        autoSize={{ minRows: 4, maxRows: 6 }}
                        onChange={(e) => setReplyText(e.target.value)}
                    />
                )}
            </Modal>
            <style>
                {`
                    .highlight-row {
                        background-color: #fff7e6;
                    }
                    .highlight-row:hover > td {
                        background-color: #ffe7ba !important;
                    }
                `}
            </style>
        </div>
    );
};

const mapStateToProps = ({ loading }) => ({
    isLoading: loading.isLoading
});

export default connect(mapStateToProps, {})(Notes);
